import { updateContract } from '../../../../api'
import { CONTRACT_FORM_DISABLED_FIELD_PROPS } from '../../Contract.constants'
import {
  getContractFormInitialValues,
  getContractUpdatedNotification,
  getContractUpdateErrorNotification,
  getContractUpdatePayload,
} from '../../ContractForm'
import { ContractFormModal } from '../../ContractFormModal'

export function useContractFormModal() {
  function handleOpenCreation({
    initialBuilding,
    initialFlat,
    initialUser,
    setModal,
    onClose,
    onEntityReload,
    onReloadList,
  }) {
    setModal(
      <ContractFormModal
        buildingFieldProps={
          initialBuilding ? CONTRACT_FORM_DISABLED_FIELD_PROPS : undefined
        }
        flatFieldProps={
          initialFlat ? CONTRACT_FORM_DISABLED_FIELD_PROPS : undefined
        }
        initialValues={getContractFormInitialValues({
          initialBuilding,
          initialFlat,
          initialUser,
        })}
        userFieldProps={
          initialUser ? CONTRACT_FORM_DISABLED_FIELD_PROPS : undefined
        }
        onClose={onClose}
        onEntityReload={onEntityReload}
        onReloadList={onReloadList}
      />
    )
  }

  function handleOpenEdit({
    contract,
    initialUser,
    setModal,
    onClose,
    onEntityReload,
    onReloadList,
  }) {
    setModal(
      <ContractFormModal
        buildingFieldProps={CONTRACT_FORM_DISABLED_FIELD_PROPS}
        delayedDateFieldProps={{ delayedDate: contract.delayed_date }}
        flatFieldProps={CONTRACT_FORM_DISABLED_FIELD_PROPS}
        getErrorNotification={getContractUpdateErrorNotification}
        getPayload={getContractUpdatePayload}
        getSuccessNotification={getContractUpdatedNotification}
        initialValues={getContractFormInitialValues({ contract, initialUser })}
        submitApi={({ data }) => updateContract({ data, id: contract.id })}
        submitButtonProps={{ title: 'Modal.SaveBtnKey' }}
        titleKey='Contract.EditTitleKey'
        userFieldProps={CONTRACT_FORM_DISABLED_FIELD_PROPS}
        onClose={onClose}
        onEntityReload={onEntityReload}
        onReloadList={onReloadList}
      />
    )
  }

  return { handleOpenCreation, handleOpenEdit }
}
